import { useStoreActions } from 'easy-peasy'
import { useRouter } from 'next/router'

export default function Container ({ children }) {
  const router = useRouter()
  const actions = useStoreActions(a => ({
    getProducts: a.getProducts
  }))

  const handleSearch = (e) => {
    if (typeof e !== 'undefined' && e.key === 'Enter') {
      actions.getProducts({ search: e.target.value, per_page: 3, page: 1 })
      router.push(`/catalog/search/${e.target.value}`)
    }
  }

  return children({
    handleSearch
  })
}
